import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';

@Component({
  selector: 'app-add-attachment',
  templateUrl: './add-attachment.component.html',
  styleUrls: ['./add-attachment.component.scss']
})
export class AddAttachmentComponent extends SuperComponent implements OnInit {

  employeeMenu: any = [];
  AttacmentMenu: any = [];
  attachmentForm: any = {};
  uploadimage: boolean = true;
  selecetdFile: File;
  fileName: string;

  Active_id: any;
  buttonOptions = {
    text: this.translate.instant('employeeduration.submit'),
    type: 'default',
    useSubmitBehavior: true,
  };

  constructor(Objects: ObjectsService,
    private location: Location,
    translate: TranslateService,
    private employeeService: EmployeeService, 
    private publicService: publicSettingService,private router:Router,
    gt: genericCustomStoreService,
  private notifyService:NotifyService) {

    super(Objects, translate, gt)
    this.getRowIdFromSubject();
  }

  ngOnInit(): void {
    this.getEmployeeMenu();
    this.getEmployeeAttachmentMenu();
    this.getDataById();
  }

  getEmployeeMenu() {
    this.gt.getdropdown('Employee').subscribe((res: any) => {
      // this.employeeMenu = res.data;
      this.employeeMenu = res;
    })
  }

  getEmployeeAttachmentMenu() {
    this.gt.getdropdowndata('EmployeeAttachmentTypes').subscribe((res: any) => {
      this.AttacmentMenu = res;
    })
  }

  onEditingStart(e: any) {
    this.addpopup = this.translate.instant('hr.EmployeeAttachment');
  }

  onEditorPreparing(e: any) {
    this.gt.onEditorPreparing(e)
  }

  getRowIdFromSubject() {
    this.employeeService.$Attachment_ID.subscribe((res: any) => {
      this.Active_id = res;
      console.log("id",res);
      
    })
  }
  openImage(imageUrl: string) {
    debugger;
  if (imageUrl) {
    window.open(imageUrl, '_blank');
  }
}
  noimag = this.translate.instant('accounting.NoImage')
  upload(event: any) {
    this.uploadimage = true; 
    this.selecetdFile = event.target.files[0];
  
    if (this.selecetdFile) {
      this.fileName = this.selecetdFile.name;
  
      const reader = new FileReader();
      reader.onload = () => {
        this.attachmentForm.fileUrl = reader.result as string; 
      };
      reader.readAsDataURL(this.selecetdFile);
    }
  }

  getDataById () {
    if(this.Active_id !=0) {
      this.publicService.byKey("EmployeeAttachment", this.Active_id.id).subscribe((res:any)=>{
        this.attachmentForm = res;
        this.fileName=res?.fileUrl
        console.log("res id", this.attachmentForm)
      })
    }else {
      this.attachmentForm = {}
    }
  }
  onFormSubmit(e: any) {
    const fromData = new FormData();
    fromData.append("id", this.attachmentForm.id);
    fromData.append("notes", this.attachmentForm.notes);
    fromData.append("employeeId", this.attachmentForm.employeeId);
    fromData.append("employeeAttachmentTypeId", this.attachmentForm.employeeAttachmentTypeId);
    fromData.append("file", this.selecetdFile??this.attachmentForm.imagePath??null);
    if (this.Active_id == 0) {
      this.publicService.add('EmployeeAttachment', fromData).subscribe((res: any) => {
        this.notifyService.notifyfun('add')
        this.router.navigate(['hr/EmployeeAttachment'])
        
      })
    }else{
      this.publicService.update('EmployeeAttachment', fromData).subscribe((res:any)=>{
        this.notifyService.notifyfun('edit')
        this.router.navigate(['hr/EmployeeAttachment'])

      })
    }
  }

  
  // backToMainPage() {
  //   this.location.back()
  // }
}
